import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'mono-common-blockquote-image',
  templateUrl: './blockquote-image.component.html'
})
export class BlockquoteImageComponent implements OnInit {

  readonly defaultLanguage = "en";

  @Input() imageSrc: string;
  @Input() image2xSrc?: string;
  @Input() quote: string;
  @Input() language?: string = this.defaultLanguage;
  @Input() secondary?: boolean = false;

  public quoteSvg: string;

  constructor() { }

  ngOnInit(): void {
    this.quoteSvg = this.svgByLanguage(this.language);
  }

  private svgByLanguage(language: string): string {
    return language === this.defaultLanguage ? "icon-quotes-left" : `icon-quotes-left-${language}`;
  }

}
